import { createSlice } from "@reduxjs/toolkit";
import {
  downloadInsertionOrder,
  downloadQuote,
  getDownloadSigned,
} from "../../../thunks/common-thunks/commonThunk";
import {
  campaignPayments,
  deleteImageFromBillBoard,
  featuredCampaignProducts,
  getOfferComments,
  getOfferDetails,
  getOwnerProducts,
  getSellerCampaigns,
  getSellerCampaignsList,
  getSellerDashboardActivities,
  getSellerPaymentsInDashboard,
  initiateSign,
  productVisibility,
  sellerCampaignsCount,
  uploadCSV,
  viewCampaignDetails,
} from "../../../thunks/seller-thunks/SellerThunk";
import { message } from "antd";
import { searchBuyerForTransferCampaign } from "../../../thunks/buyer-thunks/BuyerThunks";

const initialState = {
  isLoading: false,
  error: null,
  campaignsList: [],
  isCampaignLoading: false,
  data: [],
  buyersList: [],
  featuredCampaignsList: [],
};

export const campaignSlice = createSlice({
  name: "sellerCampaigns",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //getCampaignCount
    builder
      .addCase(sellerCampaignsCount.pending, (state) => {
        state.isCampaignLoading = true;
        state.error = null;
        state.campaigns_io = 0;
        state.campaigns_sceduled = 0;
        state.campaigns_running = 0;
        state.campaigns_closed = null;
      })
      .addCase(sellerCampaignsCount.fulfilled, (state, action) => {
        state.isCampaignLoading = false;
        state.campaigns_io = action.payload.campaigns_io;
        state.campaigns_sceduled = action.payload.campaigns_sceduled;
        state.campaigns_running = action.payload.campaigns_running;
        state.campaigns_closed = action.payload.campaigns_closed;
      })
      .addCase(sellerCampaignsCount.rejected, (state, action) => {
        state.isCampaignLoading = false;
        state.error = action;
        message.error("Something went wrong!");
      });
    // getSellerCampaigns
    builder
      .addCase(getSellerCampaigns.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSellerCampaigns.fulfilled, (state, action) => {
        state.isLoading = false;
        state.campaignsList = action.payload;
      })
      .addCase(getSellerCampaigns.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // View Campaign Details
    builder
      .addCase(viewCampaignDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(viewCampaignDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cid = action.payload.cid;
        state.name = action.payload.name;
        state.id = action.payload.id;
        state.type = action.payload.type;
        state.totalamount = action.payload.totalamount
          ? action.payload.totalamount
          : 0;
        state.total_paid = action.payload.total_paid;
        state.products = action.payload.products;
        state.products_in_campaign = action.payload.products_in_campaign;
        state.startDate = action.payload.startDate;
        state.endDate = action.payload.endDate;
        state.offer_comments = action.payload.offer_comments;
        state.percentagevalue = action.payload.percentagevalue;
        state.tax_percentage_amount_sum =
          action.payload.tax_percentage_amount_sum;
        state.gross_fee_price = action.payload.gross_fee_price;
        state.install_production_cost_sum =
          action.payload.install_production_cost_sum;
        state.totalamount = action.payload.totalamount;
        state.newprocessingfeeamtSum = action.payload.newprocessingfeeamtSum;
        state.impressionSum = action.payload.impressionSum;
        state.campaign_cpmval = action.payload.campaign_cpmval;
        state.act_budget = action.payload.act_budget;
        state.buyer_user_address = action.payload.buyer_user_address;
        state.buyer_by_name = action.payload.buyer_by_name;
        state.buyer_user_attn = action.payload.buyer_user_attn;
        state.buyer_user_email = action.payload.buyer_user_email;
        state.buyer_user_name = action.payload.buyer_user_name;
        state.offer_individual_comments =
          action.payload.offer_individual_comments;
        state.sponsor_yes_no = action.payload.sponsor_yes_no;
        state.campaign_terms_array = action.payload?.campaign_terms_array;
        state.status = action.payload.status;
        state.buyer_signature_path = action.payload.buyer_signature_path;
      })
      .addCase(viewCampaignDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // get Offer Details for seller
    builder
      .addCase(getOfferDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOfferDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.offerList = action.payload.length > 0 ? action.payload : [];
      })
      .addCase(getOfferDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // get offer Comments for seller
    builder
      .addCase(getOfferComments.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOfferComments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.offer_comments_list = action.payload;
      })
      .addCase(getOfferComments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
    // download insertion order
    builder
      .addCase(downloadInsertionOrder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(downloadInsertionOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ioPdf = action.payload;
      })
      .addCase(downloadInsertionOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // download quote
    builder
      .addCase(downloadQuote.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(downloadQuote.fulfilled, (state, action) => {
        state.isLoading = false;
        state.quotePdf = action.payload;
      })
      .addCase(downloadQuote.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // get Seller Products
    builder
      .addCase(getOwnerProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOwnerProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.products = action.payload.products;
        state.page_count = action.payload.page_count;
        state.duplicateRecords = action.payload.duplicate_array;
      })
      .addCase(getOwnerProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // import CSV
    builder
      .addCase(uploadCSV.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(uploadCSV.fulfilled, (state, action) => {
        state.isLoading = false;
        state.successMessages = action.payload?.message ?? [];
        state.errorMessages = action.payload?.error_message ?? [];
      })
      .addCase(uploadCSV.rejected, (state, action) => {
        state.isLoading = false;
        state.successMessages = action.payload?.message ?? [];
        state.errorMessages = action.payload?.error_message ?? [];
      });

    // delete image from product
    builder
      .addCase(deleteImageFromBillBoard.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteImageFromBillBoard.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.products = action.payload.products;
      })
      .addCase(deleteImageFromBillBoard.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // Product Visibility
    builder
      .addCase(productVisibility.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(productVisibility.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(productVisibility.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // Featured Campaigns of Products
    builder
      .addCase(featuredCampaignProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(featuredCampaignProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.featuredCampaignsList = action.payload.campaign_list;
      })
      .addCase(featuredCampaignProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.featuredCampaignsList = action.payload;
        message.error("Something went wrong!");
      });

    //Seller campaign Payments
    builder
      .addCase(campaignPayments.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(campaignPayments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.paymentCampaigns = action.payload;
      })
      .addCase(campaignPayments.rejected, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        message.error("Something went wrong!");
      });

    // Seller campaigns list
    builder
      .addCase(getSellerCampaignsList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSellerCampaignsList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getSellerCampaignsList.rejected, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        message.error("Something went wrong!");
      });

    // Seller Dashboard data
    builder
      .addCase(getSellerDashboardActivities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSellerDashboardActivities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dashboardData = action.payload;
      })
      .addCase(getSellerDashboardActivities.rejected, (state, action) => {
        state.isLoading = false;
        state.dashboardData = action.payload;
        message.error("Something went wrong!");
      });

    // Seller Dashboard data
    builder
      .addCase(getSellerPaymentsInDashboard.pending, (state) => {
        state.isPaymentsLoading = true;
        state.error = null;
      })
      .addCase(getSellerPaymentsInDashboard.fulfilled, (state, action) => {
        state.isPaymentsLoading = false;
        state.dashboardPaymentsData = action.payload;
      })
      .addCase(getSellerPaymentsInDashboard.rejected, (state, action) => {
        state.isPaymentsLoading = false;
        state.dashboardPaymentsData = action.payload;
        message.error("Something went wrong!");
      });

    // transfer campaign to another buyer
    builder
      .addCase(searchBuyerForTransferCampaign.pending, (state) => {
        state.searchBuyerToTransferLoading = true;
        state.error = null;
      })
      .addCase(searchBuyerForTransferCampaign.fulfilled, (state, action) => {
        state.searchBuyerToTransferLoading = false;
        state.buyersList = action.payload;
      })
      .addCase(searchBuyerForTransferCampaign.rejected, (state, action) => {
        state.searchBuyerToTransferLoading = false;
        message.error("Something went wrong!");
      });

    builder
      .addCase(initiateSign.pending, (state) => {
        state.initiateSignLoading = true;
        state.error = null;
      })
      .addCase(initiateSign.fulfilled, (state, action) => {
        state.initiateSignLoading = false;
        state.initiateSignData = action.payload;
      })
      .addCase(initiateSign.rejected, (state, action) => {
        state.initiateSignLoading = false;
        message.error("Something went wrong!");
      });
    builder

      .addCase(getDownloadSigned.pending, (state) => {
        state.isLoading = true;
        state.downloadSignedError = null;
      })

      .addCase(getDownloadSigned.fulfilled, (state, action) => {
        state.isLoading = false;
        state.downloadSignedData = action.payload;
      })

      .addCase(getDownloadSigned.rejected, (state, action) => {
        state.isLoading = false;
        state.downloadSignedError = action.payload;
      });

  },
});

export default campaignSlice.reducer;
